// import assign from 'lodash/assign';
import * as actionTypes from '../constants/actionTypes';
import _ from 'lodash';
import {List} from 'immutable';

// import * as editorNames from '../constants/editorNames';

const initialState = {
  transientStones: [],
  transientMasterStones: [],
  userUploadedStones: [],
  fetching: false,
  invalidated: false,
  sentinel: false,
  colorFilter: List(),
  materialFilter: List(),
  filterGroups: [],
  materialsFilters: List(),
  colorsFilters: List(),
  loaded: false
};

function mergeFilter(filters, newFilters) {
  newFilters.forEach(f => {
    let filter = filters.find(n => n.id == f.id);
    if(filter) {
      for(var i = 0; i < f.items.length; i++) {
        let x = _.findIndex(filter.items, n => n.id == f.items[i].id);
        if(x < 0) {
          filter.items.push(f.items[i]);
        }
      }
    } else {
      filters.push(f);
    }
  });
  return filters;
}

function setStones(state, action) {
  const {stones} = action.payload;
  
  let materialsFilters = mergeFilter(state.materialsFilters, createFilters(action.payload.filterGroups, 'Stone Material'));
  let colorsFilters = mergeFilter(state.colorsFilters, createFilters(action.payload.filterGroups, 'Stone Color'));
  
  return {...state, transientStones: stones, fetching: false, invalidated: false, sentinel: true, loaded: true, materialsFilters, colorsFilters};
}

function addStoneFilter(state, newFilter, type) {
  let newState = {...state};
  if(type == "Stone Material") {
    if(newFilter.parentId > 0) {
      newState.materialsFilters.find((f) => f.id == newFilter.parentId).items.unshift(newFilter);
    } else {
      newState.materialsFilters = state.materialsFilters.unshift(newFilter);
    }
  } else if(type == "Stone Color") {
    newState.colorsFilters = state.colorsFilters.unshift(newFilter);
  } else {
    console.log('invalid filter type in addStoneFilter', newFilter);
  }
  return newState;
}

function postProcessFilterValues(items) {
  _.forEach(items, i => {
    i.checked = false;
    i.expanded = false;
    i.hasChildren = _.size(i.items) !== 0;
    postProcessFilterValues(i.items);
  });
}


function createFilters(filterGroups, filterGroupName) {
  const filterGroup = _.find(filterGroups, {'name': filterGroupName});
  let items = [];
  if (filterGroup) {
    items = _.sortBy(_.filter(filterGroup.values, v => !/\d+x\d+/.test(v.value) && v.value.length > 1),
      [value => value.value.toLocaleLowerCase()],
      ['description', 'value']);
  }

  postProcessFilterValues(items);
  return List(items);
}

function setMasterStones(state, action) {
  const {stones} = action.payload;
  _.each(stones, function (stone) {
    stone.enabled = false;
    stone.price = 0;
  });

  return {
    ...state,
    transientMasterStones: stones,
    filterGroups: action.payload.filterGroups,
    materialsFilters: createFilters(action.payload.filterGroups, 'Stone Material'),
    colorsFilters: createFilters(action.payload.filterGroups, 'Stone Color')
  };
}

function setUserUploadedStones(state, action) {
  const {stones} = action.payload;
  let stoneList = [];
  for(var key in stones) {
    if(typeof(stones[key]) === "object") {
      stoneList.push(stones[key]);
    }
  }
  return {
    ...state,
    userUploadedStones: stoneList
  };
}

function setMaterialFilter(state, action) {
  const {item, type} = action.payload;
  //item.checked = !item.checked;
  let filter = type === 'materials' ? state.materialFilter : state.colorFilter;
  
  if (item.checked) {
    filter = filter.push(item.id);
  } else {
    do{
      const idx = filter.indexOf(item.id);
      if (idx !== -1) {
        filter = filter.splice(idx, 1);
      }
    } while(filter.indexOf(item.id) >= 0);
  }

  const filters = type === 'materials' ? state.materialsFilters : state.colorsFilters;
  const idx = filters.findIndex(_ => _.id == item.id);
  filters.set(idx, item);

  if (type === 'materials') {
    return {...state, materialFilter: filter, materialsFilters: filters};
  }

  return {...state, colorFilter: filter, colorsFilters: filters};
}

/* TODO: Marcus@HV: Repurpose this for committing transient state.
 function updateTransientStoneField(state, action) {
 const { item, key, value } = action.payload;
 const transientStones = state.transientStones.map(s =>
 ((item.id === s.id) ? assign({}, s, { [key]: value }) : s)
 );

 return { ...state, transientStones };
 }
 */

export default function stonesReducer(state = initialState, action) {
  switch (action.type) {
 /*   case actionTypes.FETCH_STONES:
      return setStones(state, action);

    case actionTypes.FETCH_MASTER_STONES:
      return setMasterStones(state, action);

    case actionTypes.FETCH_USER_UPLOADED_STONES:
      return setUserUploadedStones(state, action);

    case actionTypes.FILTER_STONES_COLOR:
      return {...state, colorFilter: action.payload};

    case actionTypes.FILTER_STONES_MATERIAL:
      return {...state, materialFilter: action.payload};

    case actionTypes.FETCHED_STONES_FILTERS:
      return {...state, materialsFilters: [].concat(action.payload)};
    case actionTypes.SET_FILTER_STONES_MATERIAL:
      return setMaterialFilter(state, action);

    case actionTypes.ADD_STONE_FILTER:
      return addStoneFilter(state, action.payload.filter, action.payload.type);

  case actionTypes.STONE_SUPPLIER_STONE_UPDATE_STORE_VALUE:
      let newState = {...state};
      for(var i = 0; i < newState.transientStones.length; i++) {
        if(action.payload.stones.filter(s => newState.transientStones[i].id == s).length == 0)
          continue;
        for(var n = 0; n < newState.transientStones[i].stoneSupplierStones.length; n++) {
          newState.transientStones[i].stoneSupplierStones[n][action.payload.field] = action.payload.value;
        }
      }
      return newState;
    case actionTypes.NEW_STONE_POPUP_ADD:
      let newState = {...state};
      let newStone = {...action.payload.stone};
      newStone.createdById = newStone.createdBy_id;
      newStone.stoneSupplierStones = [action.payload.stoneSupplierStone];
      newStone.filterValueIDs = [...action.payload.materialFilters, ...action.payload.colorFilters];
      newState.transientStones.unshift(newStone);
      return newState;
    
    case actionTypes.EDIT_STONE_POPUP_UPDATE:
      newState = {...state};
      let updatedStone = {...action.payload.stone};
      updatedStone.stoneSupplierStones = [action.payload.stoneSupplierStone];
      updatedStone.filterValueIDs = [...action.payload.materialFilters, ...action.payload.colorFilters];
      var exIndex = newState.transientStones.findIndex(v => v.id == updatedStone.id);
      newState.transientStones[exIndex] = updatedStone;
      return newState;
    case actionTypes.STONE_DELETE:
      newState = {...state};
      let stoneId = action.payload;
      var tsIndex = newState.transientStones.findIndex(v => v.id == stoneId);
      var msIndex = newState.transientMasterStones.findIndex(v => v.id == stoneId);
      if(tsIndex >= 0)
        newState.transientStones.splice(tsIndex, 1);
      if(msIndex >= 0)
        newState.transientMasterStones.splice(msIndex, 1);
      return newState;*/
    default:
      return state;
  }
}
